import React from 'react';
// import { Card } from 'react-bootstrap';
import { Container, Row, Col } from 'react-bootstrap';
import Image from 'react-bootstrap/Image';
import './HlzTeams.css';

import { hlzTeamData } from "../assets/HlzTeamData";

export function HlzTeams() {
  // console.log("get into HlzTeams()");
  return (
    <section id='hlzteams' className='block hlzteam-block'>
      <div className='title-holder text-center'>
        {/* <h1>Team Member List</h1> */}
        <h2>HLZ Team Member</h2>
        <div className='subtitle fs-3'>Some of our experts</div>
      </div>
      <Container fluid className='d-flex'>
        {/* <Container fluid className='d-flex'> */}
        <Row> {
          hlzTeamData.map(team => {
            return (
              <Col sm={3} key={team.id}>
                <Row className='image'>
                  {/* <img style={{ height: '30vh' }} src={team.image} className='mt-lg-0' alt={team.alt} /> */}
                  <Image src={team.image} alt={team.alt} />
                  <div className='overlay'>
                    <div className='socials'>
                      <ul>
                        <li><a href={team.fbLink}><i className='fab fa-facebook-f'></i></a></li>
                        <li><a href={team.twitterLink}><i className='fab fa-twitter'></i></a></li>
                        <li><a href={team.linkedinLink}><i className='fab fa-linkedin-in'></i></a></li>
                      </ul>
                    </div>
                  </div>
                </Row>
                <Row className='content text-center'>
                  <h3 className='fs-3'>{team.employname}</h3>
                  <span className='designation fs-4'>{team.designation}</span>
                  <p className='fs-6'>{team.text}</p>
                </Row>
              </Col>
            );
          })
        } </Row>
      </Container>
    </section>
  );
}

// export default HlzTeams;